import React from 'react';
import { PacingViewApiResponse } from '../endpoints/pacing.types';
import StyledDropdown from 'src/components/styled-dropdown';

interface ViewManagerProps {
  savedViews: PacingViewApiResponse[];
  selectedView?: PacingViewApiResponse;
  onSelectView: (view: PacingViewApiResponse) => void;
  className?: string;
}

const ViewManager: React.FC<ViewManagerProps> = ({
  savedViews,
  selectedView,
  onSelectView,
  className = '',
}) => {
  const getDisplayName = (view: PacingViewApiResponse): string => {
    const owner = view.owner;
    if (owner.first_name && owner.last_name) {
      return `${owner.first_name} ${owner.last_name}`;
    }
    return owner.email;
  };

  // Convert saved views to dropdown options
  const viewOptions = savedViews.map(view => ({
    value: view.id,
    label: view.name,
    subtitle: getDisplayName(view),
  }));

  const handleViewSelect = (viewId: string) => {
    const selectedView = savedViews.find(view => view.id === viewId);
    if (selectedView) {
      onSelectView(selectedView);
    }
  };

  return (
    <StyledDropdown
      options={viewOptions}
      selectedValue={selectedView?.id}
      onSelect={handleViewSelect}
      placeholder="Select View"
      className={className}
      buttonClassName='bg-gray-201 rounded-full'
    />
  );
};

export default ViewManager;